import { Component, inject, Inject, input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

/** DocViewerData is data provided to the document viewer */
export interface DocViewerData {
  documentUrl: string;
  documentType: 'pdf' | 'image' | 'other';
  title?: string;
}

/**
 * DocViewerComponent is a dialog component for viewing documents such as PDFs and images
 */
@Component({
  selector: 'app-doc-viewer',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './doc-viewer.component.html',
  styleUrl: './doc-viewer.component.scss'
})
export class DocViewerComponent {
  /** Dependency injections */
  public dialogData: DocViewerData = inject(MAT_DIALOG_DATA);
  private readonly dialogRef: MatDialogRef<DocViewerComponent> = inject(MatDialogRef);
  private readonly sanitizer: DomSanitizer = inject(DomSanitizer);

  /** Document data */
  public readonly data = input<DocViewerData>();
  public safeUrl: SafeResourceUrl;

  /**
   * Default constructor creates the safe URL for embedding
   */
  public constructor() {
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.dialogData.documentUrl);
  }

  /**
   * Close closes the dialog
   */
  public close(): void {
    this.dialogRef.close();
  }

  /** Specialized getters to get document type */

  public get isImage(): boolean {
    return this.dialogData.documentType === 'image';
  }

  public get isPdf(): boolean {
    return this.dialogData.documentType === 'pdf';
  }
}
